'use client';

import { FaLongArrowAltRight } from 'react-icons/fa';

const getSkillName = (description: string) => {
  switch (description) {
    case 'video_file':
      return 'Video';
  }
};

export const CurriculumDetailDownloads = ({ skillsDownload }: { skillsDownload: any }) => {
  skillsDownload = skillsDownload?.filter(
    (skill: any) =>
      !['motivation_letter_description', 'certificate_description'].includes(skill.name),
  );

  if (!skillsDownload || skillsDownload.length === 0) {
    return <></>;
  }

  return (
    <div className="flex w-full flex-col rounded-lg bg-[#f3f3f3] p-6">
      <h1 className="font-semibold">Na stiahnutie</h1>
      {skillsDownload?.map((skill: any) => (
        <button
          onClick={() => {
            if (skill.file_url) {
              const link = document.createElement('a');
              link.href = skill.file_url;
              link.download = skill.name || 'download'; // Use skill.name or a default name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } else {
              alert('No file URL available for download.');
            }
          }}
          className="flex gap-2 text-[#3477F5]"
          key={skill.id}
        >
          <FaLongArrowAltRight size={20} /> {getSkillName(skill.description)}
        </button>
      ))}{' '}
    </div>
  );
};
